import React from 'react';
import PropTypes from 'prop-types';
import { StyledTFoot } from './style';

const TFoot = ({ children }) => <StyledTFoot>{children}</StyledTFoot>;

TFoot.propTypes = {
  children: PropTypes.node.isRequired
};

export default TFoot;
